import 'swiper/css';
import 'swiper/css/navigation';
import './import/modules';
import './import/components';
import './import/moreSection';
import './import/swiper';
import './import/qustionsOnLoad';
import './import/openQuestion';
import './import/moreQuestions';
import './import/modal';
import './import/form';
import './import/scroll';
import './import/search';
